import React, { useEffect, useState } from 'react'
import { SearchOutlined } from '@mui/icons-material';
import { Box, CircularProgress, InputAdornment, TextField } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { selectFetchLoading, selectSearchQuery } from '../store/selectors/translationsSelectors';
import { setSearchQuery } from '../store/slices/translationsSlice';

const TranslationSearch: React.FC = () => {
    const dispatch = useAppDispatch();
    const searchQuery = useAppSelector(selectSearchQuery);
    const [searchText, setSearchText] = useState(searchQuery)
    const translationsLoading = useAppSelector(selectFetchLoading);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setSearchText(newValue);
    };

    // Debounced search function

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;
        const debouncedSearch = (() => {
            return () => {
                timeoutId = setTimeout(() => {
                    dispatch(setSearchQuery(searchText));
                }, 300); // 500ms delay
            };
        })();
        debouncedSearch();

        return () => {
            clearTimeout(timeoutId);
        };
    }, [searchText, dispatch]);


    return (
        <Box sx={styles.searchFieldBox}>
            <TextField
                slotProps={{
                    input: {
                        startAdornment: <InputAdornment position="start"><SearchOutlined /></InputAdornment>,
                        endAdornment: <CircularProgress size={16} style={{ display: !!searchText && translationsLoading ? 'block' : 'none' }} />
                    },
                }}
                fullWidth
                variant="outlined"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearchChange}
                size="small"

            />
        </Box>
    )
}

const styles = {
    searchFieldBox: {
        flex: 1,
        backgroundColor: 'background.paper',
    },
};

export default TranslationSearch